
export const CREATE_OQ_CLIENT = 'src/Measures/CREATE_OQ_CLIENT';
export const CREATE_OQ_CLIENT_SUCCESS = 'src/Measures/CREATE_OQ_CLIENT_SUCCESS';
export const CREATE_OQ_CLIENT_ERROR = 'src/Measures/CREATE_OQ_CLIENT_ERROR';

export const CREATE_OQ_EMPLOYEE = 'src/Measures/CREATE_OQ_EMPLOYEE';
export const CREATE_OQ_EMPLOYEE_SUCCESS = 'src/Measures/CREATE_OQ_EMPLOYEE_SUCCESS';
export const CREATE_OQ_EMPLOYEE_ERROR = 'src/Measures/CREATE_OQ_EMPLOYEE_ERROR';

export const GET_OQ_PROFILE = 'src/Measures/GET_OQ_PROFILE';
export const GET_OQ_PROFILE_SUCCESS = 'src/Measures/GET_OQ_PROFILE_SUCCESS';
export const GET_OQ_PROFILE_ERROR = 'src/Measures/GET_OQ_PROFILE_ERROR';

export const GET_OQ_CLIENT = 'src/Measures/GET_OQ_CLIENT';
export const GET_OQ_CLIENT_SUCCESS = 'src/Measures/GET_OQ_CLIENT_SUCCESS';
export const GET_OQ_CLIENT_ERROR = 'src/Measures/GET_OQ_CLIENT_ERROR';

export const GET_OQ_ADMINISTRATION_URL = 'src/Measures/GET_OQ_ADMINISTRATION_URL';
export const GET_OQ_ADMINISTRATION_URL_SUCCESS = 'src/Measures/GET_OQ_ADMINISTRATION_URL_SUCCESS';
export const GET_OQ_ADMINISTRATION_URL_ERROR = 'src/Measures/GET_OQ_ADMINISTRATION_URL_ERROR';

export const SEND_OQ_ADMINISTRATION_SMS = 'src/Measures/SEND_OQ_ADMINISTRATION_SMS';
export const SEND_OQ_ADMINISTRATION_SMS_SUCCESS = 'src/Measures/SEND_OQ_ADMINISTRATION_SMS_SUCCESS';
export const SEND_OQ_ADMINISTRATION_SMS_ERROR = 'src/Measures/SEND_OQ_ADMINISTRATION_SMS_ERROR';

export const SEND_OQ_ADMINISTRATION_EMAIL = 'src/Measures/SEND_OQ_ADMINISTRATION_EMAIL';
export const SEND_OQ_ADMINISTRATION_EMAIL_SUCCESS = 'src/Measures/SEND_OQ_ADMINISTRATION_EMAIL_SUCCESS';
export const SEND_OQ_ADMINISTRATION_EMAIL_ERROR = 'src/Measures/SEND_OQ_ADMINISTRATION_EMAIL_ERROR';

export const DELETE_OQ_CLIENT = 'src/Measures/DELETE_OQ_CLIENT';
export const DELETE_OQ_CLIENT_SUCCESS = 'src/Measures/DELETE_OQ_CLIENT_SUCCESS';
export const DELETE_OQ_CLIENT_ERROR = 'src/Measures/DELETE_OQ_CLIENT_ERROR';

export const DELETE_OQ_EMPLOYEE = 'src/Measures/DELETE_OQ_EMPLOYEE';
export const DELETE_OQ_EMPLOYEE_SUCCESS = 'src/Measures/DELETE_OQ_EMPLOYEE_SUCCESS';
export const DELETE_OQ_EMPLOYEE_ERROR = 'src/Measures/DELETE_OQ_EMPLOYEE_ERROR';

export const GET_OQ_SCHEDULE = 'src/Measures/GET_OQ_SCHEDULE';
export const GET_OQ_SCHEDULE_SUCCESS = 'src/Measures/GET_OQ_SCHEDULE_SUCCESS';
export const GET_OQ_SCHEDULE_ERROR = 'src/Measures/GET_OQ_SCHEDULE_ERROR';

export const SET_OQ_SCHEDULE = 'src/Measures/SET_OQ_SCHEDULE';
export const SET_OQ_SCHEDULE_SUCCESS = 'src/Measures/SET_OQ_SCHEDULE_SUCCESS';
export const SET_OQ_SCHEDULE_ERROR = 'src/Measures/SET_OQ_SCHEDULE_ERROR';

export const STOP_OQ_SCHEDULE = 'src/Measures/STOP_OQ_SCHEDULE';
export const STOP_OQ_SCHEDULE_SUCCESS = 'src/Measures/STOP_OQ_SCHEDULE_SUCCESS';
export const STOP_OQ_SCHEDULE_ERROR = 'src/Measures/STOP_OQ_SCHEDULE_ERROR';

export const GET_PATIENT_DEVICE_STATUS = 'src/Measures/GET_PATIENT_DEVICE_STATUS';
export const GET_PATIENT_DEVICE_STATUS_SUCCESS = 'src/Measures/GET_PATIENT_DEVICE_STATUS_SUCCESS';
export const GET_PATIENT_DEVICE_STATUS_ERROR = 'src/Measures/GET_PATIENT_DEVICE_STATUS_ERROR';

export const SEND_OQ_ADMINISTRATION_PUSH = 'src/Measures/SEND_OQ_ADMINISTRATION_PUSH';
export const SEND_OQ_ADMINISTRATION_PUSH_SUCCESS = 'src/Measures/SEND_OQ_ADMINISTRATION_PUSH_SUCCESS';
export const SEND_OQ_ADMINISTRATION_PUSH_ERROR = 'src/Measures/SEND_OQ_ADMINISTRATION_PUSH_ERROR';
